import { render, staticRenderFns } from "./DocumentationUpload.vue?vue&type=template&id=f5d7944a"
import script from "./DocumentationUpload.vue?vue&type=script&lang=js"
export * from "./DocumentationUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports